import { ClaimableTypes } from '@models/Claim';
import { OrderableTypes } from '@models/Order';
import { getRoute } from '@utils/route';

export const USER_DASHBOARD_ROUTE_URL = '/user-dashboard/*';

export const USER_DASHBOARD_POLICY_URL = '/user-dashboard/policy';
export const USER_DASHBOARD_SEARCH_CORPORATE_MEMBER_URL = '/user-dashboard/search-corporate-member';
export const USER_DASHBOARD_OTP_URL = '/user-dashboard/otp';
export const USER_DASHBOARD_POLICY_DETAILS_URL = '/user-dashboard/policy/:orderableType/:orderableId';
export const USER_DASHBOARD_POLICY_CLAIM_URL = '/user-dashboard/policy/:orderableType/:orderableId/claim';
export const USER_DASHBOARD_POLICY_RENEWAL_URL = '/user-dashboard/policy/:orderableType/:orderableId/renewal';

type PolicyRouteParams = {
  orderableType: OrderableTypes;
  orderableId: number;
};

export const routeUserDashboardDetails = () => getRoute(USER_DASHBOARD_POLICY_URL);
export const routeUserDashboardOtp = () => getRoute(USER_DASHBOARD_OTP_URL);
export const routeUserDashboardPolicyDetails = (routeParams: PolicyRouteParams) =>
  getRoute(USER_DASHBOARD_POLICY_DETAILS_URL, { routeParams });
export const routeUserDashboardPolicyClaim = (routeParams: PolicyRouteParams, searchParams?: object) =>
  getRoute(USER_DASHBOARD_POLICY_CLAIM_URL, { routeParams, searchParams });
export const routeUserDashboardPolicyRenewal = (routeParams: PolicyRouteParams) =>
  getRoute(USER_DASHBOARD_POLICY_RENEWAL_URL, { routeParams });

export const USER_DASHBOARD_CLAIM_DETAILS_URL = '/user-dashboard/claim/:claimableType/:claimableId';
export const USER_DASHBOARD_CLAIM_ADD_DOCUMENTS_URL = '/user-dashboard/claim/:claimableType/:claimableId/add-documents';
export const USER_DASHBOARD_CLAIM_EDIT_URL = '/user-dashboard/claim/:claimableType/:claimableId/edit';

export type ClaimRouteParams = {
  claimableType: ClaimableTypes;
  claimableId: number;
};

export const routeUserDashboardClaimDetails = (routeParams: ClaimRouteParams) =>
  getRoute(USER_DASHBOARD_CLAIM_DETAILS_URL, { routeParams });
export const routeUserDashboardClaimAddDocuments = (routeParams: ClaimRouteParams) =>
  getRoute(USER_DASHBOARD_CLAIM_ADD_DOCUMENTS_URL, { routeParams });
export const routeUserDashboardClaimEdit = (routeParams: ClaimRouteParams) =>
  getRoute(USER_DASHBOARD_CLAIM_EDIT_URL, { routeParams });


export const USER_DASHBOARD_INSURANCE_POLICY_LIST_PAGE_URL = '/user-dashboard/insurance-policy';
export const USER_DASHBOARD_INSURANCE_POLICY_DETAILS_PAGE_URL = '/user-dashboard/insurance-policy/:insurancePolicyId';

export type InsurancePolicyRouteParams = {
  insurancePolicyId: number;
};

export const routeUserDashboardInsurancePolicyListPage = () => getRoute(USER_DASHBOARD_INSURANCE_POLICY_LIST_PAGE_URL);
export const routeUserDashboardInsurancePolicyDetailsPage = (routeParams: InsurancePolicyRouteParams) => getRoute(USER_DASHBOARD_INSURANCE_POLICY_DETAILS_PAGE_URL, { routeParams });

export const USER_DASHBOARD_COMMISSION_SHARES_URL = '/user-dashboard/commission-shares';

export const routeUserDashboardCommissionShares = () => getRoute(USER_DASHBOARD_COMMISSION_SHARES_URL);
